import API from "./API"

const endpoint = "/contract-groups"

export const listOverview = ({ org_node_id, year }) =>
  API.get(`${endpoint}/list_overview?org_node_id=${org_node_id}&year=${year}`)

export const getSupplySheds = ({ org_node_id, year, group_id }) =>
  API.get(`${endpoint}/get_supply_sheds/${group_id != null ? `?group_id=${group_id}&` : '?'}org_node_id=${org_node_id}&year=${year}`)

export const submitSupplyRequests = ({ year, group_id, fss_supply_shed_ids }) =>
  API.post(`${endpoint}/submit_supply_requests/`, { year, group_id, fss_supply_shed_ids })

export const applyFssStatusChangePending = ({ fss_ids }) =>
  API.post(`${endpoint}/apply_fss_status_change_pending/`, { fss_ids })

export const submitEvidencingLink = ({ group_id, updated_link_obj }) =>
  API.post(`${endpoint}/submit_evidencing_link/`, { group_id, updated_link_obj })

export const addProfileToGroup = ({ client_profile_id, org_node_id, group_id, year, as_cp_profile }) =>
  API.post(`${endpoint}/add_client_profile_to_group/`, { client_profile_id, org_node_id, group_id, year, as_cp_profile })

export const swapGroupProfile = ({ org_node_id, year, group_id, from_id, to_id, as_cp_profile }) =>
  API.post(`${endpoint}/swap_client_profile/`, { org_node_id, year, group_id, from_id, to_id, as_cp_profile })

export const removeProfileFromGroup = ({ org_node_id, year, group_id, remove_id, as_cp_profile }) =>
  API.post(`${endpoint}/remove_profile_from_group/`, { org_node_id, year, group_id, remove_id, as_cp_profile })

export const createProfile = ({ org_node_id, year, group_id, as_cp_profile, profile_dataset }) =>
  API.post(`${endpoint}/create_new_profile/`, { org_node_id, year, group_id, as_cp_profile, profile_dataset })

export const updateProfile = ({ org_node_id, year, group_id, profile_dataset, profile_id }) =>
  API.post(`${endpoint}/update_profile/`, { org_node_id, year, group_id, profile_dataset, profile_id })

export const submitConfirmRequests = ({ year, fss_ids }) =>
  API.post(`${endpoint}/submit_confirm_requests/`, { year, fss_ids })

export const fetchClientProfiles = () =>
  API.get("/client-profile/?get_parent_org=1")

export const fetchGroupClientProfiles = ({ group_id }) =>
  API.get(`/client-profile/?group_id=${group_id}`)

export const listFieldsForEntityManagement = ({ org_node_id, year }) =>
  API.get(`${endpoint}/list_fields_for_entity_management/?org_node_id=${org_node_id}&year=${year}`)

export const updateLegalEntityMetadata = ({ group_id, name, notes }) =>
  API.post(`${endpoint}/update_legal_entity_metadata/`, { group_id, name, notes })

export const removeFieldsFromLegalEntity = ({ group_id, fss_ids }) =>
  API.post(`${endpoint}/remove_fss_from_legal_entity/`, { group_id, fss_ids })

export const addFieldsToLegalEntity = ({ group_id, fss_ids }) =>
  API.post(`${endpoint}/add_fss_to_legal_entity/`, { group_id, fss_ids })

export const createNewLegalEntity = (payload) =>
  API.post(`${endpoint}/create_new_legal_entity/`, payload, { headers: { "Content-Type": "multipart/form-data" } })

export const deleteLegalEntity = ({ group_id }) =>
  API.post(`${endpoint}/delete_legal_entity/`, { group_id })
